import script from "./TableButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./TableButtons.vue?vue&type=script&setup=true&lang=js"

import "./TableButtons.vue?vue&type=style&index=0&id=7e940f5c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e940f5c"]])

export default __exports__